import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';
import _ from 'lodash';

import { getLocalMarkData, setLocalMarkData } from 'chat/api/stick';
import { setLocalListType, getLocalListType } from 'chat/api/operate-data';
import { getLocalClueData, setLocalClueData } from 'chat/api/clue';
import { getLocalUnreadData, setLocalUnreadData } from 'chat/api/unread';

const initState = Map({
  // 消息置顶
  stick: [],
  clientTag: [],
  convTags: [],
  convTagsConfig: [],
  unRead: {},
  colleaguesHasnext: false,
  nextCursor: -1,
  replyTimeout: {},
  // 对话消息框中记录的内容 如 【对话标签，对话小结】
  centerConv: {},
  // 输入框的历史文本内容,
  messageContent: {},
  // 不同对话回复的对话类型
  convsResType: {},
  // 对话的状态（首次未响应等）
  convStatus: [],
  // 选中的tab项
  listTabType: 'mine',
  // 抓取的线索
  clue: [],
  /*
   * 智能推荐的列表 map结构 key为对话id, value为对话最新的搜索的内容
   */
  latestIntelligentRecommend: {}
});

export const {
  clearConvStatus,
  getStick,
  updateStick,
  updateConvTags,
  updateConvTagsConfig,
  getUnRead,
  addUnReads,
  clearUnRead,
  setReplyTimeout,
  setCenterConv,
  setConvStatus,
  setMessageContent,
  reduceMessageContent,
  appendConvStatus,
  updateConvStatus,
  getListTabType,
  setListTabType,
  getClue,
  updateClue,
  setConvsResType,
  updateConvVisitInfo,
  updateLatestIntelligentRecommendByConvId,
  deleteLatestIntelligentRecommendByConvId
} = createActions({
  CLEAR_CONV_STATUS: action => {
    return action;
  },
  GET_STICK: () => {
    return getLocalMarkData();
  },
  UPDATE_STICK: action => {
    return action;
  },
  UPDATE_CONV_TAGS: async () => {},
  UPDATE_CONV_TAGS_CONFIG: async () => {},
  GET_UN_READ: async () => {
    const result = await getLocalUnreadData();
    return result;
  },
  ADD_UN_READS: result => result,
  CLEAR_UN_READ: result => result,
  SET_REPLY_TIMEOUT: result => result,
  SET_CENTER_CONV: result => result,
  SET_CONV_STATUS: result => result,
  SET_MESSAGE_CONTENT: result => result,
  REDUCE_MESSAGE_CONTENT: result => result,
  APPEND_CONV_STATUS: result => result,
  UPDATE_CONV_STATUS: result => result,
  GET_LIST_TAB_TYPE: async () => {
    const result = await getLocalListType();
    return result;
  },
  SET_LIST_TAB_TYPE: result => result,
  GET_CLUE: () => {
    return getLocalClueData();
  },
  UPDATE_CLUE: action => {
    return action;
  },
  SET_CONVS_RES_TYPE: result => result,
  updateConvVisitInfo: result => result,
  MOVE_CONVERSATION_FROM_COLLEAGUE_TO_TRUSTEESHIP: result => result,
  updateLatestIntelligentRecommendByConvId: result => result,
  deleteLatestIntelligentRecommendByConvId: result => result
});

const conversation = handleActions(
  {
    [clearConvStatus]: state => {
      return state.set('replyTimeout', {});
    },

    [getStick]: (state, action) => {
      return state.set('stick', action.payload);
    },
    [updateStick](state, action) {
      const { payload: convId } = action;

      const convsIds = [...state.get('stick')];
      const ind = convsIds.indexOf(convId);

      if (ind === -1) {
        convsIds.push(convId);
      } else {
        convsIds.splice(ind, 1);
      }
      setLocalMarkData(convsIds);
      return state.set('stick', convsIds);
    },
    [updateConvTags]: state => {
      return state;
    },

    [updateConvTagsConfig]: state => {
      return state;
    },
    [getUnRead]: (state, action) => {
      return state.set('unRead', action.payload);
    },
    [addUnReads]: (state, action) => {
      const { trackIds } = action.payload;

      let unRead = _.clone(state.get('unRead'));
      trackIds.forEach(trackId => {
        if (unRead[trackId]) {
          unRead = {
            ...unRead,
            ...{ [trackId]: unRead[trackId] + 1 }
          };
        } else {
          unRead = {
            ...unRead,
            ...{ [trackId]: 1 }
          };
        }
      });
      setLocalUnreadData(unRead);
      return state.set('unRead', unRead);
    },
    [clearUnRead]: (state, action) => {
      const { trackIds } = action.payload;
      const unRead = _.clone(state.get('unRead'));
      trackIds.map(val => delete unRead[val]);
      setLocalUnreadData(unRead);
      return state.set('unRead', unRead);
    },
    [setReplyTimeout]: (state, action) => {
      const { convId, ...rest } = action.payload;
      return state.setIn(['replyTimeout', [convId]], rest);
    },
    [setCenterConv]: (state, action) => {
      const { convId, value } = action.payload;
      return state.updateIn(['centerConv', [convId]], val => {
        return {
          ...val,
          ...value
        };
      });
    },
    [setConvStatus]: (state, action) => {
      return state.set('convStatus', action.payload);
    },
    [setMessageContent]: (state, action) => {
      const {
        payload: { content, convId }
      } = action;
      return state.updateIn(['messageContent', [convId]], () => content);
    },
    [reduceMessageContent]: (state, action) => {
      const {
        payload: { content, convId }
      } = action;
      return state.updateIn(['messageContent', [convId]], data => `${data ? `${data}\n` : ''}${content}`);
    },
    [appendConvStatus]: (state, action) => {
      return state.update('convStatus', data => {
        // 对话数据中不存在对话进行【append】 存在则动态改变
        const { payload } = action;
        const findInOldData = convId => data.find(item => item.convId === convId);
        const newStatus = payload.filter(item => !findInOldData(item.convId));

        const findInNewData = convId => payload.find(item => item.convId === convId);
        const oldStatus = _.map(data, value => {
          const newStatus = findInNewData(value.convId);
          if (newStatus) {
            return { ...value, ...newStatus };
          }
          return value;
        });
        return [...newStatus, ...oldStatus];
      });
    },
    [updateConvStatus]: (state, action) => {
      return state.update('convStatus', data => {
        const { payload } = action;
        const { convId, ...rest } = payload;
        // 对话数据中不存在对话进行【append】 存在则动态改变
        const oldDataHasConv = data.some(item => item.convId === convId);
        if (oldDataHasConv) {
          return _.map(data, value => {
            if (value.convId === convId) {
              return { ...value, ...rest };
            }
            return value;
          });
        }
        return [...data, payload];
      });
    },
    [getListTabType]: (state, action) => {
      if (action.payload) {
        return state.set('listTabType', action.payload);
      }
      return state;
    },
    [setListTabType]: (state, action) => {
      setLocalListType(action.payload);
      return state.set('listTabType', action.payload);
    },
    [getClue]: (state, action) => {
      return state.set('clue', action.payload);
    },
    [updateClue](state, action) {
      const { payload } = action;
      const { convId } = payload;
      const convClue = _.clone(state.get('clue'));
      const ind = convClue.findIndex(conv => conv.convId === convId);
      if (ind === -1) {
        convClue.push(payload);
      } else {
        const activeClue = convClue[ind];
        const result = [...activeClue.clue, ...payload.clue].slice(-3);
        convClue.splice(ind, 1, {
          clue: result,
          convId
        });
      }
      setLocalClueData(convClue);
      return state.set('clue', convClue);
    },
    [setConvsResType]: (state, action) => {
      return state.set('convsResType', action.payload);
    },
    // 添加或删除对话的智能推荐[最新的一条]
    [updateLatestIntelligentRecommendByConvId]: (state, action) => {
      const { payload } = action;
      const { convId, content } = payload;
      const latestIntelligentRecommend = _.clone(state.get('latestIntelligentRecommend'));

      latestIntelligentRecommend[convId] = content;

      return state.set('latestIntelligentRecommend', latestIntelligentRecommend);
    },
    [deleteLatestIntelligentRecommendByConvId]: (state, action) => {
      const { payload } = action;
      const { convId } = payload;

      const latestIntelligentRecommend = _.clone(state.get('latestIntelligentRecommend'));

      try {
        delete latestIntelligentRecommend[convId];
      } catch (err) {}

      return state.set('latestIntelligentRecommend', latestIntelligentRecommend);
    }
  },
  initState
);

export default conversation;
